<template>
  <div>
    <VideoCanvas :video-el="videoEl" />
    <VideoAngleCanvas :video-el="videoEl" />

    <DrawingControls />
  </div>
</template>

<script lang="ts" setup>
import DrawingControls from './DrawingControls.vue';
import VideoAngleCanvas from './VideoAngleCanvas.vue';
import VideoCanvas from './VideoCanvas.vue';

defineProps<{
  videoEl?: HTMLVideoElement;
}>();
</script>
